import React, { useState } from 'react';
import MainStructure from '../components/general/MainStructure';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPinterest } from "@fortawesome/free-brands-svg-icons";
import { faLink, faPaperPlane, faHeading } from "@fortawesome/free-solid-svg-icons";
import ImageUploader from './ImageUploader';
import MediaPicker from './MediaPicker';
import pinterestLogo from "../assets/pinterest.png";
import "react-datepicker/dist/react-datepicker.css";
import TimezoneSelector from './components/TimezoneSelector';
import { useEffect } from 'react';


function WritePinterestPost() {
    const myContext = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    
    // Form State
    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [pinLink, setPinLink] = useState('https://');
    const [uploadedImages, setUploadedImages] = useState([]);
    const [uploadedMedia, setUploadedMedia] = useState([]);
    const [showPicker, setShowPicker] = useState(false);
    const [pickerType, setPickerType] = useState('images'); // 'images' | 'videos'

    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());

    const pinterestAccounts = myContext.accounts.filter(acc => acc.type === 'pinterest');
const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

const PinterestPreview = ({ title, text, media, pinLink }) => {
    // Check if the media is a video
    const isVideo = media?.[0]?.type === 'video' || (typeof media?.[0]?.url === 'string' && media[0].url.endsWith('.mp4'));
    const mediaUrl = media?.[0]?.url || media?.[0];



    useEffect(() => {
        const fetchUserTimezone = async () => {
            try {
                const response = await fetch('https://api.schedpilot.com/wp-json/schedpilot/v1/get-settings', {
                    method: 'GET',
                    credentials: 'include',
                });
                const data = await response.json();
                if (response.ok && data.timezone) {
                    setTimezone(data.timezone);
                }
            } catch (err) {
                console.error("Could not load preferred timezone", err);
            }
        };
        fetchUserTimezone();
    }, []);




    return (
        <div className="card shadow-sm border-0" style={{ borderRadius: '32px', overflow: 'hidden', maxWidth: '300px', margin: '0 auto' }}>
            {/* Aspect Ratio Container (Pinterest style is usually 2:3) */}
            <div style={{ 
                position: 'relative', 
                backgroundColor: '#efefef', 
                width: '100%',
                paddingTop: '150%', // This creates a 2:3 Aspect Ratio
                overflow: 'hidden'
            }}>
                {mediaUrl ? (
                    isVideo ? (
                        <video 
                            src={mediaUrl} 
                            autoPlay 
                            muted 
                            loop 
                            style={{ 
                                position: 'absolute', 
                                top: 0, 
                                left: 0, 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'cover' 
                            }} 
                        />
                    ) : (
                        <img 
                            src={mediaUrl} 
                            alt="Preview" 
                            style={{ 
                                position: 'absolute', 
                                top: 0, 
                                left: 0, 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'cover' 
                            }} 
                        />
                    )
                ) : (
                    <div 
                        className="d-flex align-items-center justify-content-center" 
                        style={{ 
                            position: 'absolute', 
                            top: 0, 
                            left: 0, 
                            width: '100%', 
                            height: '100%', 
                            color: '#767676' 
                        }}
                    >
                        <span>Media Preview</span>
                    </div>
                )}
            </div>

            {/* Content Section */}
            <div className="p-3 bg-white">
                <h6 className="fw-bold text-truncate" style={{ fontSize: '1.1rem', marginBottom: '4px' }}>
                    {title || "Pin Title"}
                </h6>
                <p className="small text-muted mb-2 text-truncate" style={{ fontSize: '0.85rem' }}>
                    {text || "Your description will appear here..."}
                </p>
                <div className="d-flex align-items-center bg-light p-2 rounded-pill" style={{ fontSize: '0.75rem' }}>
                    <FontAwesomeIcon icon={faLink} className="me-2 text-secondary" />
                    <span className="text-truncate" style={{ maxWidth: '180px' }}>
                        {pinLink ? pinLink.replace('https://', '').replace('http://', '') : 'yourwebsite.com'}
                    </span>
                </div>
            </div>
        </div>
    );
};


const formatLocalDate = (date) => {
  const pad = (num) => String(num).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};


    const handlePost = async (status = "publish") => {
        // Validation Logic
        const m = Array.isArray(myContext.membership) ? myContext.membership[0] : myContext.membership;
        const isLifetime = m?.plan?.type === "lifetime" || (
            m?.end_date_time
                ? new Date(m.end_date_time.replace(' ', 'T') + 'Z').getTime() > Date.now() + 10 * 365 * 24 * 3600 * 1000
                : false
        );
        if (!myContext.isValidMembership() && !isLifetime) {
            return toast.error("Your membership is expired. It cannot post.");
        }
        if (!selectedAccounts.length) {
            return toast.error("Please select at least one Pinterest account");
        }
        if (!title || title.length < 5) {
            return toast.error("Please enter a valid Title for your Pin (min 5 chars)");
        }
        if (!text || text.length < 10) {
            return toast.error("Please enter a Description for your Pin (min 10 chars)");
        }

        if (!uploadedMedia.length) 
        {
            return toast.error("Please upload an image or video for your Pin");
        }

        setLoading(true);
        try {
            const response = await fetch('https://api.schedpilot.com/wp-json/api/v1/schedulePostPinterest', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
              scheduledDate: formatLocalDate(selectedDate),
              timezone: timezone,
                    videoTitle: title, 
                    text: text,
                    postStatus: status,
                    pinterestLink: pinLink,
                    media: uploadedMedia, // send the array containing image or video URLs
                    mediaType: uploadedMedia[0]?.type === 'video' ? 'video' : 'image',
                    accounts: selectedAccounts, 
                    platform: 'pinterest'
                }),
            });
            
            const res = await response.json();
            
            if (res.ok || res.success || response.ok) {
                // 1. Show Success Toast (Matching WritePost behavior)
                if (status === "draft") {
                    toast.success("Draft saved successfully!");
                    // If your context has a specific draft adder:
                    if(myContext.addDraftItem) {
                        myContext.addDraftItem({
                            pid: res.post_id || res.data?.id,
                            content: text,
                            scheduled_date: selectedDate
                        });
                    }
                } else {
                    toast.success("Post sent to scheduler successfully!");
                    // Update global context so the dashboard reflects changes immediately
                    if(myContext.addScheduledItem) {
                        myContext.addScheduledItem(res.data || res);
                    }
                }

                // 2. Clear Form State
                setTitle('');
                setText('');
                setPinLink('https://');
                setUploadedImages([]);
                setSelectedAccounts([]);

                // 3. Redirect to Dashboard
                navigate('/dashboard');
            } else {
                toast.error(res.message || "Failed to schedule Pin");
            }
        } catch (error) {
            console.error("Pinterest Post Error:", error);
            toast.error("Error connecting to server. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <MainStructure activeItem={"write-post"}>
            <div className="container py-4">
                <div className="d-flex align-items-center mb-4">
                    <img src={pinterestLogo} alt="Pinterest" style={{ width: 40, height: 40, marginRight: 15 }} />
                    <h1 className="h3 mb-0" style={{ fontWeight: 800 }}>Create Pinterest Pin</h1>
                    <Button variant="outline-secondary" size="sm" className="ms-3" onClick={() => navigate(-1)}>Go Back</Button>
                </div>

                <div className="row">
                    <div className="col-lg-8">
                        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: '15px' }}>
                            <label className="fw-bold mb-2">Media (Image or Video)</label>
                            {/* Note: Ensure your ImageUploader component is updated to accept video files */}
                            <ImageUploader
                                uploadedImages={uploadedMedia}
                                setUploadedImages={setUploadedMedia}
                                allowVideo={true}
                            />

                            <div className="d-flex align-items-center gap-2 mt-2">
                                <span className="text-muted small">or pick from your library:</span>
                                <Button variant="outline-secondary" size="sm" onClick={() => { setPickerType('images'); setShowPicker(true); }}>
                                    Image from library
                                </Button>
                                <Button variant="outline-secondary" size="sm" onClick={() => { setPickerType('videos'); setShowPicker(true); }}>
                                    Video from library
                                </Button>
                            </div>

                            <label className="fw-bold mt-4 mb-2">Pin Title</label>
                            <div className="input-group mb-3">
                                <span className="input-group-text"><FontAwesomeIcon icon={faHeading} /></span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    maxLength={100}
                                    value={title} 
                                    onChange={(e) => setTitle(e.target.value)}
                       
                                    placeholder="Enter a catchy title..."
                                />
                            </div>
                            <small className="text-muted d-block text-end mt-n2 mb-3">{title.length}/100</small>

                            <label className="fw-bold mb-2">Destination Link</label>
                            <div className="input-group mb-3">
                                <span className="input-group-text"><FontAwesomeIcon icon={faLink} /></span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    value={pinLink} 
                                    onChange={(e) => setPinLink(e.target.value)}
                                    placeholder="https://yourwebsite.com"
                                />
                            </div>

                            <label className="fw-bold mt-2 mb-2">Pin Description</label>
                            <textarea 
                                className="form-control" 
                                rows="5" 
                                value={text} 
                                onChange={(e) => setText(e.target.value)}
                                placeholder="Tell everyone what your Pin is about..."
                            ></textarea>
                            <small className="text-muted d-block text-end mt-1">{text.length}/500</small>
                        </div>
                    </div>

                    <div className="col-lg-4" >
                        <div className="mb-4"> 

            <div class="" style={{backgroundColor: '#fff', border:"1px solid #eee",
                paddingTop:15,paddingBottom:15, borderRadius: '15px'}}>
            <PinterestPreview 
                title={title} 
                text={text} 
                media={uploadedMedia} 
                pinLink={pinLink} 
            /></div>
        </div>

                        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: '15px' }}>
                            <h5 className="fw-bold mb-3"><FontAwesomeIcon icon={faPaperPlane} className="me-2" /> Schedule Pin</h5>
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                showTimeSelect
                                dateFormat="MMMM d, yyyy h:mm aa"
                                className="form-control mb-4"
                            />


                            {/* 6. Add the Timezone Selector here */}
                            <TimezoneSelector 
                                value={timezone} 
                                onChange={setTimezone} 
                                label="Scheduling Timezone"
                                className="mb-5"
                            />

                            <h5 className="fw-bold mb-3"><FontAwesomeIcon icon={faPinterest} className="me-2 text-danger" /> Target Accounts</h5>
                            <div className="account-selector p-2 border rounded" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {pinterestAccounts.length > 0 ? (
                                    pinterestAccounts.map(acc => {
                                        const accountValue = `${acc.id}_pinterest`;
                                        return (
                                            <div key={acc.id} className="d-flex align-items-center mb-2 p-2 border-bottom">
                                                <input 
                                                    type="checkbox" 
                                                    className="me-3"
                                                    checked={selectedAccounts.includes(accountValue)}
                                                    onChange={(e) => {
                                                        setSelectedAccounts(prev => 
                                                            e.target.checked ? [...prev, accountValue] : prev.filter(i => i !== accountValue)
                                                        );
                                                    }}
                                                />
                                                <img src={acc.image} alt="" style={{ width: 30, height: 30, borderRadius: '50%', marginRight: 10 }} />
                                                <span className="fw-semibold">{acc.name}</span>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p className="small text-muted mb-0">No Pinterest accounts connected.</p>
                                )}
                            </div>

                            <div className="d-grid gap-2 mt-4">
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    onClick={() => handlePost()} 
                                    disabled={loading}
                                >
                                    {loading ? <Spinner size="sm" className="me-2" /> : null}
                                    Schedule Pin
                                </Button>
                                <Button 
                                    variant="light" 
                                    onClick={() => handlePost("draft")}
                                    disabled={loading}
                                >
                                    Save as Draft
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <MediaPicker
                show={showPicker}
                type={pickerType}
                onHide={() => setShowPicker(false)}
                onSelect={(item) => {
                    setUploadedMedia([{
                        url: item.file_url,
                        id: item.id,
                        type: pickerType === 'videos' ? 'video' : 'image',
                    }]);
                    setShowPicker(false);
                }}
            />
        </MainStructure>
    );
}

export default WritePinterestPost;